/** Size of an `IconAvatar`: MD matches list rows next to a `UserAvatar`, LG matches selection cards. */
export enum EIconAvatarSize {
  MD = 'md',
  LG = 'lg',
}
